var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.apiDocsLoaded)?_c('div',{staticClass:"container"},[_c('Spinner',{staticClass:"spinner"}),(_vm.label)?_c('div',{staticClass:"label"},[_vm._v(_vm._s(_vm.label))]):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }